export class LocalStorage {
    static saveUserData(id, token, userType, agencyStatus, language, clientId = null, isDashboMcp = false, freeTrialDaysRemaining = null, agencyLogoUrl = null, agencyDisplayName = null, brandPrimaryColor = null, brandSecondaryColor = null) {
        localStorage.setItem('logged_user_id', id);
        localStorage.setItem('logged_user_token', token);
        localStorage.setItem('logged_user_type', userType);
        localStorage.setItem('logged_agency_status', agencyStatus);
        localStorage.setItem('logged_user_language', language);
        localStorage.setItem('logged_is_dashbo_mcp', isDashboMcp ? 'true' : 'false');

        if (freeTrialDaysRemaining !== null && freeTrialDaysRemaining !== undefined) {
            localStorage.setItem('logged_free_trial_days_remaining', String(freeTrialDaysRemaining));
        } else {
            localStorage.removeItem('logged_free_trial_days_remaining');
        }

        if (clientId !== null) {
            localStorage.setItem('logged_user_client_id', clientId);
        } else {
            localStorage.removeItem('logged_user_client_id');
        }

        if (agencyLogoUrl) {
            localStorage.setItem('logged_agency_logo_url', agencyLogoUrl);
        } else {
            localStorage.removeItem('logged_agency_logo_url');
        }

        if (agencyDisplayName) {
            localStorage.setItem('logged_agency_display_name', agencyDisplayName);
        } else {
            localStorage.removeItem('logged_agency_display_name');
        }

        if (brandPrimaryColor) {
            localStorage.setItem('logged_brand_primary_color', brandPrimaryColor);
        } else {
            localStorage.removeItem('logged_brand_primary_color');
        }

        if (brandSecondaryColor) {
            localStorage.setItem('logged_brand_secondary_color', brandSecondaryColor);
        } else {
            localStorage.removeItem('logged_brand_secondary_color');
        }
    }

    static saveColumnWidth(columnId, width) {
        // Lee los anchos almacenados de localStorage, si existen
        const columnWidths = JSON.parse(localStorage.getItem('columnWidths')) || {};

        // Actualiza el ancho de la columna correspondiente
        columnWidths[columnId] = width;

        // Guarda de nuevo en localStorage
        localStorage.setItem('columnWidths', JSON.stringify(columnWidths));
    }

    static hasUserData() {
        return localStorage.getItem('logged_user_id') !== null &&
            localStorage.getItem('logged_user_token') !== null &&
            localStorage.getItem('logged_user_type') !== null &&
            localStorage.getItem('logged_user_language') !== null &&
            (localStorage.getItem('logged_user_type') === 'AGENCY_USER' ||
                localStorage.getItem('logged_user_type') === 'CLIENT_USER' ||
                localStorage.getItem('logged_user_client_id') !== null);
    }

    static hasUserClientId() {
        return localStorage.getItem('logged_user_client_id') !== null;
    }

    static removeUserData() {
        localStorage.removeItem('logged_user_id');
        localStorage.removeItem('logged_user_token');
        localStorage.removeItem('logged_user_type');
        localStorage.removeItem('logged_user_language');
        localStorage.removeItem('logged_user_client_id');
        localStorage.removeItem('logged_agency_status');
        localStorage.removeItem('logged_agency_id');
        localStorage.removeItem('logged_is_dashbo_mcp');
        localStorage.removeItem('logged_free_trial_days_remaining');
        localStorage.removeItem('logged_agency_logo_url');
        localStorage.removeItem('logged_agency_display_name');
        localStorage.removeItem('logged_brand_primary_color');
        localStorage.removeItem('logged_brand_secondary_color');
    }

    static fetchUserId() {
        return localStorage.getItem('logged_user_id');
    }

    static fetchUserLanguage() {
        return localStorage.getItem('logged_user_language');
    }

    static fetchUserToken() {
        return localStorage.getItem('logged_user_token');
    }

    static fetchUserType() {
        return localStorage.getItem('logged_user_type');
    }

    static fetchAgencyStatus() {
        return localStorage.getItem('logged_agency_status');
    }

    static updateAgencyStatus(agencyStatus) {
        localStorage.setItem('logged_agency_status', agencyStatus);
    }

    static fetchAgencyId() {
        return localStorage.getItem('logged_agency_id');
    }

    static updateAgencyId(agencyId) {
        localStorage.setItem('logged_agency_id', agencyId);
    }

    static fetchIsDashboMcp() {
        return localStorage.getItem('logged_is_dashbo_mcp') === 'true';
    }

    static updateIsDashboMcp(value) {
        localStorage.setItem('logged_is_dashbo_mcp', value ? 'true' : 'false');
    }

    static fetchFreeTrialDaysRemaining() {
        const value = localStorage.getItem('logged_free_trial_days_remaining');
        if (value === null) return null;
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? null : parsed;
    }

    static updateFreeTrialDaysRemaining(days) {
        if (days !== null && days !== undefined) {
            localStorage.setItem('logged_free_trial_days_remaining', String(days));
        } else {
            localStorage.removeItem('logged_free_trial_days_remaining');
        }
    }

    static fetchUserClientId() {
        return localStorage.getItem('logged_user_client_id');
    }

    static isClientUser() {
        return localStorage.getItem('logged_user_type') === 'CLIENT_USER';
    }

    static fetchAgencyLogoUrl() {
        return localStorage.getItem('logged_agency_logo_url');
    }

    static fetchAgencyDisplayName() {
        return localStorage.getItem('logged_agency_display_name');
    }

    static fetchBrandPrimaryColor() {
        return localStorage.getItem('logged_brand_primary_color');
    }

    static fetchBrandSecondaryColor() {
        return localStorage.getItem('logged_brand_secondary_color');
    }

    static saveDataExplorerSearchParams(searchParams) {
        const dataToSave = {
            ...searchParams,
            timestamp: Date.now(),
        };
        localStorage.setItem('data_explorer_last_search', JSON.stringify(dataToSave));
    }

    static getDataExplorerSearchParams() {
        const savedData = localStorage.getItem('data_explorer_last_search');
        if (!savedData) {
            return null;
        }
        
        try {
            const parsed = JSON.parse(savedData);
            return parsed;
        } catch (error) {
            console.error('Error parsing saved search params:', error);
            return null;
        }
    }

    static shouldAutoExecuteSearch() {
        const savedData = this.getDataExplorerSearchParams();
        if (!savedData || !savedData.timestamp) {
            return false;
        }
        
        const twoHoursInMs = 2 * 60 * 60 * 1000; // 2 horas en milisegundos
        const timeSinceLastSearch = Date.now() - savedData.timestamp;
        
        return timeSinceLastSearch < twoHoursInMs;
    }

    static saveHeatMapEnabled(enabled) {
        localStorage.setItem('data_explorer_heat_map_enabled', JSON.stringify(enabled));
    }

    static getHeatMapEnabled() {
        const saved = localStorage.getItem('data_explorer_heat_map_enabled');
        if (saved === null) {
            // Por defecto es true
            return true;
        }
        try {
            return JSON.parse(saved);
        } catch (error) {
            console.error('Error parsing heat map enabled:', error);
            return true; // Por defecto es true
        }
    }

    static saveDataExplorerChartPreferences(prefs) {
        localStorage.setItem('data_explorer_chart_prefs', JSON.stringify(prefs));
    }

    static getDataExplorerChartPreferences() {
        const saved = localStorage.getItem('data_explorer_chart_prefs');
        if (!saved) return null;
        try {
            return JSON.parse(saved);
        } catch (error) {
            return null;
        }
    }

    static saveRedirectUrl(url) {
        localStorage.setItem('redirect_after_login', url);
    }

    static getRedirectUrl() {
        return localStorage.getItem('redirect_after_login');
    }

    static clearRedirectUrl() {
        localStorage.removeItem('redirect_after_login');
    }
}
